import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './onboarding-module.module.css';

type Props = {
    illustration: React.ReactNode;
    title: string;
    description: string;
    rightSection: React.ReactNode;
};

export function OnboardingModuleCardContent(props: Props) {
    return (
        <Stack spacing={0} isHorizontal={true} alignItems='center' isFullWidth={true}>
            <div className={styles.illustration}>{props.illustration}</div>
            <div className='px-24 py-16 full-width'>
                <Stack
                    spacing={24}
                    justifyContent='space-between'
                    isHorizontal={true}
                    alignItems='center'
                    isFullWidth={true}
                >
                    <Stack spacing={4} alignItems='start'>
                        <Body
                            size='large'
                            useDoyle={true}
                            isBold={true}
                            color='dark'
                            textAlign='left'
                        >
                            {props.title}
                        </Body>
                        <Body textAlign='left'>{props.description}</Body>
                    </Stack>
                    {props.rightSection}
                </Stack>
            </div>
        </Stack>
    );
}
